import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { borderRadius, colors, spacing, typography } = themeVariables;

export const arrivesByLabel = css`
  display: block;
  margin: var(${spacing.xxs}) 0 var(${spacing.sm});
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});

  em {
    font-style: normal;
    color: var(${colors.content.positive});
  }
`;

export const deliveryOptionsList = css`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const item = css`
  margin: 0;
  border-top: 1px solid var(${colors.stroke.default});
  padding: var(${spacing.sm}) 0;
`;

export const promotionContainer = css`
  margin: var(${spacing.sm}) 0;
  border-radius: var(${borderRadius.md.desktop});
  padding: var(${spacing.xs});
  background-color: var(${colors.surface.positive});
`;

export const promotionMessageOverride = css`
  margin: 0;
  padding: 0;
  border-top: none;
`;

export const optionInfo = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: var(${spacing.md});
`;

export const optionPrices = css`
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});

  [data-price='0'] {
    color: var(${colors.content.positive});
  }

  // pre-sale price
  span {
    margin-right: var(${spacing.xs});
    text-decoration: line-through;
    color: var(${colors.content.tertiary});
    font-size: var(${typography.body.sizes.md.fontSize});
    line-height: var(${typography.body.sizes.md.lineHeight});
  }

  // price when there's a pre-sale price
  span + [data-price] {
    color: var(${colors.content.negative});
  }
`;

/* The delivery date is an <h6> structurally, but the design sets it in body text rather
   than the heading face, so the theme's global h1-h6 rule is overridden here. */
export const optionHeading = css`
  margin: 0 0 var(${spacing.xxs});
  font-family: var(${typography.body.fontFamily});
  font-weight: var(${typography.body.fontWeight});
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});

  b {
    color: var(${colors.content.default});
  }

  span {
    color: var(${colors.content.positive});
    font-weight: var(${typography.body.fontWeight});
  }
`;

export const optionBody = css`
  margin: 0;
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});

  b {
    font-weight: 700;
  }
`;

export const optionPrice = css`
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  color: var(${colors.content.default});
`;
